import { ContentCopy, OpenInNew } from '@mui/icons-material';
import React from 'react';
import { Tooltip } from '@mui/material';
import styles from './SupplierUtilCell.module.scss';
import { Supplier } from 'types';

interface SupplierUtilCellProps {
    supplier: Supplier;
}

export function SupplierUtilCell({ supplier }: SupplierUtilCellProps) {
    const handleOpenSupplier = (e: React.MouseEvent) => {
        e.stopPropagation();
        window.open(
            `/supplier-details/${supplier.supplierId}/accounts`,
            '__blank'
        );
    };

    const handleCopy = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (navigator) {
            navigator.clipboard.writeText(supplier.supplierId);
        }
    };

    return (
        <div className={styles.container} data-testid="SupplierUtilCell">
            <Tooltip title="Copy Supplier Id">
                <ContentCopy onClick={handleCopy} />
            </Tooltip>
            <Tooltip title="Open supplier in new tab">
                <OpenInNew onClick={handleOpenSupplier} />
            </Tooltip>
        </div>
    );
}
